var map = {
	"./deposit.png": 6318,
	"./events.png": 7073,
	"./eye.png": 3295,
	"./gameRecords.png": 6248,
	"./inbox.png": 1576,
	"./logout.png": 4684,
	"./profile.png": 5071,
	"./records.png": 3154,
	"./redeem.png": 4574,
	"./vip.png": 5977,
	"./withdraw.png": 6080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5849;